import React from 'react';
import PropTypes from 'prop-types';
import styled, { css } from 'styled-components';
import { customMinResponsive, size } from 'components/styles';

const InputRadio = ({
	name,
	value,
	onChange,
	onBlur,
	id,
	label,
	checked,
	disabled
}) => {
	return (
		<Container>
			<Label>
				<Input
					id={id}
					type="radio"
					name={name}
					value={value}
					onChange={onChange}
					onBlur={onBlur}
					checked={checked}
					disabled={disabled}
				/>

				<Circle />

				{label}
			</Label>
		</Container>
	);
};

const Container = styled.div`
	line-height: 1;
`;

const Label = styled.label`
	display: inline-block;
	position: relative;
	padding-left: 3.2rem;
	color: ${({ theme }) => theme.radio.label.color};
	font-weight: ${({ theme }) => theme.font.normal};
	font-size: ${({ theme }) => theme.fontSize.radio.mobile}rem;
	line-height: 1.4rem;

	${customMinResponsive(
		size.medium,
		css`
			font-size: ${({ theme }) => theme.fontSize.radio.desktop}rem;
			font-weight: ${({ theme }) => theme.font.medium};
			line-height: 2.1rem;
		`
	)}
`;

const Circle = styled.span`
	display: block;
	width: 1.8rem;
	height: 1.8rem;
	border-radius: 50%;
	border: ${({ theme }) => `1px solid ${theme.radio.circle.border}`};
	position: absolute;
	left: 0;
	top: 0;
	cursor: pointer;

	&:after {
		display: none;
		content: '';
		width: 1rem;
		height: 1rem;
		border-radius: 50%;
		position: absolute;
		top: 0.3rem;
		left: 0.3rem;
		background: ${({ theme }) => theme.radio.circle.bg};
	}
`;

const Input = styled.input`
	position: absolute;
	visibility: hidden;

	&:checked + ${Circle} {
		&:after {
			display: block;
		}
	}
`;

InputRadio.defaultProps = {
	onBlur: () => {},
	id: null,
	label: '',
	checked: null,
	disabled: false
};

InputRadio.propTypes = {
	name: PropTypes.string.isRequired,
	value: PropTypes.string.isRequired,
	onChange: PropTypes.func.isRequired,
	onBlur: PropTypes.func,
	id: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
	label: PropTypes.string,
	checked: PropTypes.bool,
	disabled: PropTypes.bool
};

export default InputRadio;
